<script setup lang="ts">
import { MetaLayout } from '@/@vxapp/@Enums/MetaLayout'
import { Subject } from '@/@vxapp/@Enums/PHP/Auth/Ability/Subjects/DataProviders/AbilitySubject'
import InstagramFeedsCard from '@/views/setup/instagram/InstagramFeedsCard.vue'

definePage({
  meta: {
    subject: Subject.AUTH_LOGIN,
    action: 'read',
    layout: MetaLayout.Blank,
    notLoggedIn: true,
  },
})
</script>

<template>
  <VContainer
    fluid
    data-testid="meta-instagram-accounts-harness"
  >
    <VRow>
      <VCol cols="12">
        <InstagramFeedsCard />
      </VCol>
    </VRow>
  </VContainer>
</template>
